type DateFormat = 'YYYY-MM-DD' | 'DD-MM-YYYY';

const getFormattedDate = (
  y: string,
  m: string,
  d: string,
  fmt: DateFormat,
  delimiter = '/',
): string => {
  if (fmt === 'YYYY-MM-DD') return [y, m, d].join(delimiter);
  return [d, m, y].join(delimiter);
};

const getFormattedTime = (
  h: string,
  mn: string,
  s: string,
  delimiter = ':',
): string => {
  return [h, mn, s].join(delimiter);
};

export const formatDate = (
  date?: Date,
  dateFormat: DateFormat = 'YYYY-MM-DD',
  includeTime = true,
  delimiter = '-',
  timeDelimiter = ':',
): string => {
  if (!date) return '--';
  const y = String(date.getFullYear());
  const m = `0${date.getMonth() + 1}`.slice(-2);
  const d = `0${date.getDate()}`.slice(-2);
  const dateString = getFormattedDate(y, m, d, dateFormat, delimiter);
  if (!includeTime) return dateString;
  const h = `0${date.getHours()}`.slice(-2);
  const mn = `0${date.getMinutes()}`.slice(-2);
  const s = `0${date.getSeconds()}`.slice(-2);
  const timeString = getFormattedTime(h, mn, s, timeDelimiter);
  return [dateString, timeString].join(' ');
};
